var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 193,
    viewBox: "0 0 221 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 83,
    width: 192,
    height: 110,
    fill: "url(#paint0_linear_2023_38694)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.166 52.3048C105.039 50.8015 110.247 50.7643 115.14 52.1978L201.676 77.5467C207.399 79.2232 207.437 87.3173 201.729 89.0469L115.378 115.214C110.337 116.742 104.95 116.702 99.9323 115.101L18.214 89.0202C12.618 87.2343 12.6564 79.3026 18.2695 77.5709L100.166 52.3048Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.43 63.3333C103.572 63.3016 98.4544 63.1084 92.5771 62.8298C88.5807 62.6144 84.9992 60.0621 83.6787 56.4774C80.3126 47.3511 79.8027 42.8861 78.5677 32.1036L78.4062 30.7039C78.0421 27.4644 78.9921 24.2503 81.0852 21.6599C83.3146 18.9018 86.5319 17.1854 90.1387 16.8308C96.0034 16.2544 103.046 15.8903 109.459 15.8333C116.036 15.8934 123.325 16.2544 129.396 16.8308C133.186 17.1918 136.676 19.0253 138.962 21.8594C141.024 24.4118 141.958 27.5499 141.591 30.6976L141.461 31.7933C140.182 42.7214 139.653 47.2403 136.141 56.4426C134.748 60.1033 131.093 62.6113 126.837 62.8329C120.757 63.1084 115.459 63.3016 109.43 63.3333Z",
    fill: "#BDCEEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.697 13.6801C124.028 13.1417 116.65 12.7301 109.43 12.6667C102.432 12.7301 95.3067 13.1417 89.8283 13.6801C80.835 14.5667 74.28 22.3884 75.2617 31.0651C76.6233 42.9084 77.0667 47.6901 80.7083 57.5701C82.4817 62.3834 87.1367 65.7084 92.425 65.9934C98.4417 66.2784 103.572 66.4684 109.43 66.5001C115.478 66.4684 120.767 66.2784 127.005 65.9934C132.483 65.7084 137.265 62.3834 139.102 57.5701C142.87 47.6901 143.345 42.9084 144.738 31.0651C145.752 22.3884 138.975 14.5667 129.697 13.6801ZM130.235 57.3484C129.728 58.6151 128.208 59.5651 126.562 59.6601C120.26 59.9767 115.225 60.1351 109.43 60.1667C103.857 60.1351 98.9483 59.9767 92.9 59.6601C91.4117 59.5967 90.0817 58.6784 89.6383 57.4434C86.8833 50.0017 84.6983 33.1551 84.6983 33.1551C84.54 31.6034 84.9833 30.0517 86.0283 28.7851C87.1683 27.3601 88.8467 26.4734 90.7467 26.3151C96.8583 25.7134 103.477 25.3967 109.43 25.3651C115.573 25.3967 122.445 25.7134 128.81 26.3151C130.9 26.5051 132.8 27.4867 134.035 29.0067C134.732 29.8617 135.523 31.2867 135.302 33.1234C135.302 33.1234 133.053 49.9384 130.235 57.3484Z",
    fill: "url(#paint1_linear_2023_38694)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3334 53.8333C99.0823 53.8333 100.5 52.4156 100.5 50.6667C100.5 48.9178 99.0823 47.5 97.3334 47.5C95.5845 47.5 94.1667 48.9178 94.1667 50.6667C94.1667 52.4156 95.5845 53.8333 97.3334 53.8333Z",
    fill: "url(#paint2_linear_2023_38694)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110 53.8333C111.749 53.8333 113.167 52.4156 113.167 50.6667C113.167 48.9178 111.749 47.5 110 47.5C108.251 47.5 106.833 48.9178 106.833 50.6667C106.833 52.4156 108.251 53.8333 110 53.8333Z",
    fill: "url(#paint3_linear_2023_38694)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.667 53.8333C124.416 53.8333 125.833 52.4156 125.833 50.6667C125.833 48.9178 124.416 47.5 122.667 47.5C120.918 47.5 119.5 48.9178 119.5 50.6667C119.5 52.4156 120.918 53.8333 122.667 53.8333Z",
    fill: "url(#paint4_linear_2023_38694)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2023_38694",
    x1: 206,
    y1: 138,
    x2: 14,
    y2: 138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFBFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2023_38694",
    x1: 110.001,
    y1: 12.6667,
    x2: 110.001,
    y2: 66.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCCEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4873F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2023_38694",
    x1: 97.3334,
    y1: 47.5,
    x2: 97.3334,
    y2: 53.8333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCCEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4873F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2023_38694",
    x1: 110,
    y1: 47.5,
    x2: 110,
    y2: 53.8333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCCEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4873F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2023_38694",
    x1: 122.667,
    y1: 47.5,
    x2: 122.667,
    y2: 53.8333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCCEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4873F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.0afac6ad9770646a34c397aff6b5eca4.svg";
export { ForwardRef as ReactComponent };